var _path, _path2, _path3, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14,0C6.27,0,0,6.27,0,14s6.27,14,14,14,14-6.27,14-14S21.73,0,14,0Z",
    strokeWidth: 0
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.32,15.58v5.42h-3.14v-5.05c0-1.27-.46-2.14-1.59-2.14-.87,0-1.38.58-1.61,1.15-.08.2-.1.48-.1.77v5.28h-3.14s.04-8.57,0-9.45h3.14v1.34c.42-.64,1.16-1.56,2.83-1.56,2.07,0,3.62,1.35,3.62,4.25Z",
    fill: "#fff",
    fillRule: "evenodd",
    strokeWidth: 0
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.21,8.63c0,.91-.68,1.63-1.78,1.63h-.02c-1.06,0-1.73-.72-1.73-1.63s.7-1.63,1.77-1.63c1.08,0,1.74.71,1.76,1.63Z",
    fill: "#fff",
    fillRule: "evenodd",
    strokeWidth: 0
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 6.86,
    y: 11.56,
    width: 3.14,
    height: 9.45,
    fill: "#fff",
    strokeWidth: 0
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIn);
export default __webpack_public_path__ + "static/media/in.39b6d5e99e7c3cfe245b4364bc3c5a90.svg";
export { ForwardRef as ReactComponent };